export default class AGGridColumnTemplate{
  static linkWithBGColorTemplate(valueFormatted: string | null | undefined, link: string, bgColor: string | null | undefined, noClick?: boolean) {
    let bg = '';
    let fg = '';
    let fgForDark = '';
    if (bgColor) {
      bg = `background-color:${bgColor};`
      fg = this.getBestTextColor(bgColor);
      fgForDark = this.getBestTextColor(bgColor);
    } else {
      fg = `primary`
      fgForDark = `primaryForDark`
    }
    return `<a style='${bg}' ${noClick ? "onclick='if(!event.ctrlKey) event.preventDefault();'" : ""} class="tw-text-${fg} dark:tw-text-${fgForDark} tw-cursor-pointer" href='${link}' title='${valueFormatted}'>${valueFormatted ?? "draft"}</a>`
  }

  static linkInBlank(link: string,title:string) {
    return `<a class="tw-text-primary-light dark:tw-text-primary-dark tw-cursor-pointer" href='${link}' target='_blank' title='${title}'>${title}</a>`
  }

  static attachmentTemplate(fileId: string, entityType: string, fileName: string) {
    /*TODO::  onmouseout='previewAttachmentMouseOut(this);' onmouseover='previewAttachment(this,${fileId},${entityType},${fileName})'*/
    return `<a class='tw-text-primary-light dark:tw-text-primary-dark tw-cursor-pointer tw-underline tw-whitespace-nowrap' href='file.download?fileID=${fileId}&ischanged=false' target='_blank'>${fileName}</a>`
  }

  static getBestTextColor(hexColor: string) {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? 'black' : 'white';
  }
}
